import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  withStyles,
  CircularProgress,
} from "@material-ui/core";
import products from "../../service/products";
import DialogError from "../alertas/DialogError";
import { parseDecimal, formatQuantity } from "../../libs/format";

const TYPE_LABELS = {
  in: "Entrada",
  out: "Saída",
  adjustment: "Ajuste",
};

// Estoque de um produto: histórico de movimentações (imutável) + registrar nova.
// in soma, out subtrai, adjustment DEFINE o saldo (valor absoluto).
// Props: product, close(), onChanged(currentStock).
class StockDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      movements: [],
      loading: true,
      currentStock: props.product.current_stock,
      type: "in",
      quantity: "",
      reason: "",
      saving: false,
      showError: false,
      error: null,
    };
  }

  componentDidMount() {
    this.load();
  }

  load = () => {
    this.setState({ loading: true });
    products
      .listStockMovements(this.props.product.id)
      .then((movements) => this.setState({ movements, loading: false }))
      .catch(() => this.setState({ loading: false }));
  };

  register = () => {
    const quantity = parseDecimal(this.state.quantity);
    if (quantity === null || quantity < 0) {
      this.setState({
        showError: true,
        error: {
          title: "Quantidade inválida",
          message: "Informe uma quantidade positiva.",
        },
      });
      return;
    }
    this.setState({ saving: true });
    products
      .registerMovement(this.props.product.id, {
        type: this.state.type,
        quantity,
        reason: this.state.reason || null,
      })
      .then((result) => {
        const currentStock = result ? result.current_stock : this.state.currentStock;
        this.setState({
          saving: false,
          quantity: "",
          reason: "",
          currentStock,
        });
        this.props.onChanged(currentStock);
        this.load();
      })
      .catch((err) => {
        this.setState({
          saving: false,
          showError: true,
          error: {
            title: "Erro ao registrar movimentação",
            message:
              (err && err.data && err.data.message) ||
              "Não foi possível registrar a movimentação.",
          },
        });
      });
  };

  render() {
    const { classes } = this.props;
    return (
      <Dialog open onClose={() => this.props.close()} maxWidth="md" fullWidth>
        <DialogError
          open={this.state.showError}
          onClose={() => this.setState({ showError: false })}
          title={this.state.error ? this.state.error.title : "Erro"}
          message={this.state.error ? this.state.error.message : ""}
          suggestion={"Verifique os dados e tente novamente."}
        />
        <DialogTitle>
          Estoque — {this.props.product.name}
        </DialogTitle>
        <DialogContent>
          <Typography variant="h6" className={classes.saldo}>
            Saldo atual: {formatQuantity(this.state.currentStock)}
          </Typography>

          <div className={classes.form}>
            <FormControl className={classes.type}>
              <InputLabel id="mov-type-label">Tipo</InputLabel>
              <Select
                labelId="mov-type-label"
                value={this.state.type}
                onChange={(e) => this.setState({ type: e.target.value })}
              >
                <MenuItem value="in">Entrada (soma)</MenuItem>
                <MenuItem value="out">Saída (subtrai)</MenuItem>
                <MenuItem value="adjustment">Ajuste (define o saldo)</MenuItem>
              </Select>
            </FormControl>
            <TextField
              label="Quantidade"
              type="number"
              value={this.state.quantity}
              onChange={(e) => this.setState({ quantity: e.target.value })}
            />
            <TextField
              className={classes.reason}
              label="Motivo"
              value={this.state.reason}
              onChange={(e) => this.setState({ reason: e.target.value })}
            />
            <Button
              color="primary"
              variant="contained"
              onClick={this.register}
              disabled={this.state.saving}
            >
              {this.state.saving && (
                <CircularProgress size={20} style={{ marginRight: 8 }} />
              )}
              Registrar
            </Button>
          </div>

          <Typography variant="subtitle1" className={classes.histTitle}>
            Histórico
          </Typography>
          {this.state.loading ? (
            <div style={{ textAlign: "center", padding: 20 }}>
              <CircularProgress />
            </div>
          ) : (
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Data</TableCell>
                    <TableCell>Tipo</TableCell>
                    <TableCell align="right">Quantidade</TableCell>
                    <TableCell>Motivo</TableCell>
                    <TableCell>Usuário</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.movements.map((m) => (
                    <TableRow key={m.id}>
                      <TableCell>
                        {m.created_at
                          ? new Date(m.created_at).toLocaleString()
                          : ""}
                      </TableCell>
                      <TableCell>{TYPE_LABELS[m.type] || m.type}</TableCell>
                      <TableCell align="right">
                        {formatQuantity(m.quantity)}
                      </TableCell>
                      <TableCell>{m.reason || ""}</TableCell>
                      <TableCell>{m.user ? m.user.name : ""}</TableCell>
                    </TableRow>
                  ))}
                  {this.state.movements.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={5} align="center">
                        Sem movimentações.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.props.close()} color="primary">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const styles = (theme) => ({
  saldo: {
    marginBottom: theme.spacing(2),
    fontWeight: "bold",
  },
  form: {
    display: "flex",
    alignItems: "flex-end",
    gap: theme.spacing(2),
    flexWrap: "wrap",
    marginBottom: theme.spacing(3),
  },
  type: {
    minWidth: 180,
  },
  reason: {
    flex: 1,
    minWidth: 200,
  },
  histTitle: {
    fontWeight: "bold",
    marginBottom: theme.spacing(1),
  },
});

export default withStyles(styles)(StockDialog);
